import { legacy } from '@/shared/api/client';
import type { Product, ProductRedemptionType } from '@/shared/types/product';

export async function fetchProducts(idPassbook: string): Promise<Product[]> {
  const data = await legacy.get<Product[]>(`/products/${idPassbook}/true`, {
    headers: { 'X-Passbook-Id': idPassbook },
  });
  return Array.isArray(data) ? data : [];
}

export interface ProductFormPayload {
  action: 'insert' | 'edit' | 'deleted';
  id?: string;
  idPassbook: string;
  uniqueId: string;
  name: string;
  value: number;
  redemption: boolean;
  redemptionType: ProductRedemptionType;
  price: string;
}

export async function saveProduct(payload: ProductFormPayload) {
  await legacy.post('/product', payload, { headers: { 'X-Passbook-Id': payload.idPassbook } });
}
